import api from "./Api";

class TipoEstoqueService {
  GetTipoEstoque(payload) {
    return api.get("/v1/tipoEstoque/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTipoEstoque(payload) {
    return api.post("/v1/tipoEstoque/", payload).then((response) => {
      return response.data;
    });
  }

  PutTipoEstoque(payload) {
    return api.put("/v1/tipoEstoque/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTipoEstoque(payload) {
    return api.delete("/v1/tipoEstoque/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTipoEstoqueOData(payload) {
    return api.get("/OData/TipoEstoque" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TipoEstoqueService();
